import React from "react";
import styles from "./Tab.module.scss";

function Tab({ tabs = [], activeTab, onTabChange, children, className = "" }) {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.tabList}>
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab || activeTab === index;
          return (
            <button
              key={index}
              className={`${styles.tab} ${isActive ? styles.active : ""}`}
              onClick={() => onTabChange(tab)}
              type="button"
            >
              {tab}
            </button>
          );
        })}
      </div>
      <div className={styles.contentPanel}>{children}</div>
    </div>
  );
}

export default Tab;
